<template>
  <div
    class="course-card-item"
    :class="{
      'is-cancel': item.courseStatus === 2,
      'is-edit-mode': editMode != 0,
    }"
    @click="courseCardClickHandler(item)"
  >
    <div class="choose-nav">
      <!--删除：禁用已点名、编辑：已点名、已取消-->
      <van-checkbox
        :value="item.checked"
        icon-size="var(--fs-lg)"
        :disabled="editMode == 2 ? (item.courseStatus == 1) : (item.courseStatus !== 0)"
      />
    </div>
    <div class="course-warraper">
      <div class="course-card-top van-hairline--bottom">
        <div class="l1 normal reserve-status" :class="{ 'is-late': item.endTime <= Date.now() }">
          <div class="is-reserve" v-if="item.enableReserve">约</div>
          <div class="van-ellipsis" v-if="item.coursePlanType === 0">{{ item.className }}</div>
          <div class="van-ellipsis" v-else>{{ item.curriculumName }}</div>
        </div>
        <div class="l2">
          <span v-if="showWeek"
            >{{ item.startTime | formatDatetime('MM-dd') }}（{{
              item.startTime | getWeek()
            }}）</span
          >
          <span
            >{{ item.startTime | formatDatetime('hh:mm') }}-{{
              item.endTime | formatDatetime('hh:mm')
            }}
            · {{ item.courseAmount }}{{lessonUnit}}</span
          >
        </div>
      </div>
      <div class="course-contian">
        <div class="left">
          <div class="l2 van-ellipsis" v-if="item.campusName">校区：{{ item.campusName }}</div>
          <div class="l2 van-ellipsis" v-if="item.classRoomName">
            教室：{{ item.classRoomName }}
          </div>
          <div class="l2" v-if="getTeachers(item.courseArrangeTeacherVoList) !== '--'">
            <div class="van-ellipsis">老师：{{ getTeachers(item.courseArrangeTeacherVoList) }}</div>
          </div>
          <div class="l2" v-if="getAssitants(item.courseArrangeTeacherVoList) !== '--'">
            <div class="van-ellipsis">
              助教：{{ getAssitants(item.courseArrangeTeacherVoList) }}
            </div>
          </div>
          <div class="l2" v-if="item.students && item.students.length">
            <div class="van-ellipsis">学员：{{ item.students | getStudents }}</div>
          </div>
        </div>
        <div class="right">
          <!-- <van-button size="small" type="primary" class="gray-button" round v-if="item.courseStatus == 2">
            已取消
          </van-button> -->
          <van-button
            size="small"
            square
            round
            type="primary"
            :class="{ 'gray-button': item.signNum == item.signTotalNum }"
            v-if="item.courseStatus === 1"
          >
            已点名
          </van-button>
          <van-button
            size="small"
            square
            round
            type="primary"
            @click.stop="gotoCourseArrange(item.id)"
            v-else-if="app.permission.op('update_course_sign') && item.courseStatus === 0"
          >
            去点名
          </van-button>
          <div class="status" v-if="item.courseStatus != 2">
            {{ item.signNum }}/{{ item.signTotalNum }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// courstStatus：0未点名1已点名2已取消
export default {
  name: 'CourseCard',
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    editMode: {
      type: Number,
      default: 0,
    },
    showWeek: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...Vuex.mapState(['lessonUnit']),
  },
  filters: {
    getStudents(students) {
      if (!students || !students.length) return '';
      return students.map(v => v.studentName).join('、');
    },
  },
  methods: {
    getTeachers(teachers) {
      if (!teachers || !teachers.length) return '--';
      return (
        teachers
          .filter(v => v.teacherRule === 0)
          .map(v => v.teacherName)
          .join('、') || '--'
      );
    },
    getAssitants(teachers) {
      if (!teachers || !teachers.length) return '--';
      return (
        teachers
          .filter(v => v.teacherRule === 1)
          .map(v => v.teacherName)
          .join('、') || '--'
      );
    },
    courseCardClickHandler(item) {
      if (this.editMode == 1|| this.editMode == 2) {
        if (this.editMode == 1) {
          item.courseStatus === 0 && this.$set(item, 'checked', !item.checked);
        } else {
          (item.courseStatus === 0 || item.courseStatus ===2) && this.$set(item, 'checked', !item.checked);
        }
      } else {
        this.gotoCourseArrange(item.id);
      }
    },
    gotoCourseArrange(id) {
      if (!app.permission.op('update_course_sign || cancel_course_sign')) {
        return false;
      }
      this.$router.push(`/courseArrange/${id}`);
    },
  },
};
</script>
<style lang="scss" scoped>
/*  课程卡片  */
.course-card-item {
  display: block;
  margin-bottom: calc(var(--gap) * 12);

  color: var(--g6);
  font-size: var(--fs-md);
  line-height: var(--lh-md);
  .course-warraper {
    padding: calc(var(--gap) * 12) 0 calc(var(--gap) * 12) calc(var(--gap) * 16);
    border-radius: var(--radius-sm);
    background-color: var(--white);
  }
  .course-card-top {
    margin: 0 calc(var(--gap) * 16) calc(var(--gap) * 6) 0;
    overflow: hidden;
    .l1 {
      display: flex;
      align-items: center;
    }
    .l2 {
      padding: 0;
      margin: calc(var(--gap) * 2) 0 calc(var(--gap) * 8);
    }
  }
  .choose-nav {
    display: none;
    width: calc(var(--w) * 16);
    margin: 0 calc(var(--gap) * 12) 0 0;
  }
  .course-contian {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .l1 {
    font-size: var(--fs-lg);
    line-height: var(--lh-lg);
    font-weight: var(--bold);
    color: var(--g8);
    &.is-late {
      color: var(--g5);
    }
  }
  .l2 {
    padding: calc(var(--gap) * 4) 0;
    font-size: var(--fs-md);
    line-height: var(--lh-md);
    color: var(--g6);
    display: flex;
    align-items: center;
    .van-icon,
    .vxs-icon {
      color: #949baa;
      margin-right: calc(var(--gap) * 4);
      font-size: var(--fs-lg);
      line-height: var(--lh-lg);
    }
    .half {
      width: 40%;
      display: flex;
      align-items: center;
      margin-right: calc(var(--gap) * 8);
    }
  }
  .reserve-status {
    display: flex;
    align-items: center;
    .is-reserve {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: calc(var(--gap) * 8);
      height: calc(var(--w) * 20);
      font-size: var(--fs-sm);
      width: calc(var(--w) * 20);
      min-width: calc(var(--w) * 20);
      border-radius: var(--radius-base);
      background-color: var(--c2);
      color: var(--white);
    }
  }
  .left {
    // flex:1 1 auto;
    width: calc(100% - calc(var(--w) * 100));
    overflow: hidden;
  }
  .right {
    width: calc(var(--w) * 100);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .status {
      color: var(--g6);
      font-size: var(--fs-md);
      line-height: var(--lh-md);
      margin-top: calc(var(--gap) * 4);
    }
    .gray-button {
      background-color: var(--g2);
      border-color: var(--g2);
      color: var(--g5);
    }
  }

  &.is-cancel {
    .course-warraper {
      background: var(--white)
        url(https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/0091.png) bottom right/105px
        105px no-repeat;
    }
    .l1,
    .l2 {
      opacity: 0.4;
    }
  }

  &.is-edit-mode {
    display: flex;
    align-items: center;
    .course-contian {
      .right {
        display: none;
      }
    }

    .choose-nav {
      display: block;
    }
    .course-warraper {
      flex: 1;
      overflow: hidden;
      .left {
        padding-right: calc(var(--gap) * 16);
        width: 100%;
      }
    }
  }
}
</style>